import React from 'react';
import {
  View,
  Text,
  Image,
  ScrollView,
  StyleSheet,
  TouchableOpacity,
} from 'react-native';
import { MaterialCommunityIcons } from '@expo/vector-icons';

const CharacterDetailScreen = ({ route, navigation }) => {
  const { character } = route.params;

  return (
    <ScrollView style={styles.container}>
      <Image
        source={{ uri: character.image || 'https://via.placeholder.com/300' }}
        style={styles.image}
        resizeMode="contain"
      />
      <View style={styles.infoContainer}>
        <Text style={styles.name}>{character.name}</Text>
        
        <View style={styles.infoRow}>
          <MaterialCommunityIcons name="account" size={24} color="#f4511e" />
          <Text style={styles.infoText}>Race: {character.race || 'Unknown'}</Text>
        </View>

        <View style={styles.infoRow}>
          <MaterialCommunityIcons name="gender-male-female" size={24} color="#f4511e" />
          <Text style={styles.infoText}>Gender: {character.gender || 'Unknown'}</Text>
        </View>

        <View style={styles.infoRow}>
          <MaterialCommunityIcons name="lightning-bolt" size={24} color="#f4511e" />
          <Text style={styles.infoText}>Ki: {character.ki || 'Unknown'}</Text>
        </View>

        <View style={styles.infoRow}>
          <MaterialCommunityIcons name="lightning-bolt-outline" size={24} color="#f4511e" />
          <Text style={styles.infoText}>Max Ki: {character.maxKi || 'Unknown'}</Text>
        </View>

        <View style={styles.infoRow}>
          <MaterialCommunityIcons name="account-group" size={24} color="#f4511e" />
          <Text style={styles.infoText}>Affiliation: {character.affiliation || 'Unknown'}</Text>
        </View>

        <View style={styles.descriptionContainer}>
          <Text style={styles.descriptionTitle}>Description</Text>
          <Text style={styles.description}>{character.description || 'No description available'}</Text>
        </View>
      </View>
    </ScrollView>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#f5f5f5',
  },
  image: {
    width: '100%',
    height: 300,
    backgroundColor: '#f0f0f0',
  },
  infoContainer: {
    padding: 20,
  },
  name: {
    fontSize: 24,
    fontWeight: 'bold',
    color: '#333',
    marginBottom: 20,
    textAlign: 'center',
  },
  infoRow: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 15,
    backgroundColor: 'white',
    padding: 10,
    borderRadius: 8,
    elevation: 2,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.2,
    shadowRadius: 2,
  },
  infoText: {
    fontSize: 16,
    color: '#333',
    marginLeft: 10,
  },
  descriptionContainer: {
    marginTop: 20,
    backgroundColor: 'white',
    padding: 15,
    borderRadius: 8,
    elevation: 2,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.2,
    shadowRadius: 2,
  },
  descriptionTitle: {
    fontSize: 18,
    fontWeight: 'bold',
    color: '#333',
    marginBottom: 10,
  },
  description: {
    fontSize: 16,
    color: '#666',
    lineHeight: 24,
  },
});

export default CharacterDetailScreen; 